import { render, staticRenderFns } from "./answerMsgDialog.vue?vue&type=template&id=5f899b3f&scoped=true&"
import script from "./answerMsgDialog.vue?vue&type=script&lang=js&"
export * from "./answerMsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./answerMsgDialog.vue?vue&type=style&index=0&id=5f899b3f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f899b3f",
  null
  
)

export default component.exports